import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=541dcc9a&"
import script from "./SummaryCard.vue?vue&type=script&lang=js&"
export * from "./SummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports